// extracted by mini-css-extract-plugin
module.exports = {"favorites":"Favorites_favorites__1Kj5m"};